var React = require('react');

function IconSocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentcolor","d":"M5.9,0C3.155,0,1.919,1.225,1.919,3.571h0v2.5H0V9.249H1.919v9.329H5.6V9.21H8.171l.273-3.134V6.071H5.6V4.285c0-.739.147-1.031.85-1.031H8.444V0Z","transform":"translate(0 0)"}));
}

IconSocialFacebook.defaultProps = {"className":"svg-icon","viewBox":"0 0 8.444 19"};

module.exports = IconSocialFacebook;

IconSocialFacebook.default = IconSocialFacebook;
